import type { FC } from 'react';
import { useIntl } from 'react-intl';

import type { FulfillmentStatus } from '@/components/MyOrders/ReturnedOrders/ReturnOrderStatusStepper';
import { RETURN_ORDER_STATUS_MESSAGE_MAPPING } from '@/components/MyOrders/ReturnedOrders/ReturnOrderStatusStepper';
import { Typography } from '@/components/Typography';
import { useRouter } from '@/hooks/useRouter';
import * as PM from '@/messages/payment';

import * as S from '../OrderDetailsView.styles';

interface OrderLineReturnInfoProps {
  cancelReturnComment?: string;
  fulfillmentId?: string;
  onGuestViewReturnDetails?: (fulfillmentId: string) => void;
  orderId?: string;
  returnStatus?: string;
  showReturnDetailsLink?: boolean;
}

export const OrderLineReturnInfo: FC<OrderLineReturnInfoProps> = ({
  cancelReturnComment,
  fulfillmentId,
  onGuestViewReturnDetails,
  orderId,
  returnStatus,
  showReturnDetailsLink = true,
}) => {
  const { formatMessage } = useIntl();
  const { paths, push } = useRouter();

  if (!orderId || !fulfillmentId || !returnStatus) return null;

  const statusLabel =
    RETURN_ORDER_STATUS_MESSAGE_MAPPING[returnStatus as FulfillmentStatus];

  const handleViewReturnDetailsClick = () => {
    if (onGuestViewReturnDetails) {
      onGuestViewReturnDetails(fulfillmentId);
      return;
    }

    push(
      paths.myAccount.myOrders.returnOrderDetails.url({
        orderId,
        returnOrderId: fulfillmentId,
        query: {
          type: 'RETURNHISTORY',
        },
      }),
    );
  };

  return (
    <S.OrderLineReturnInfoWrap>
      <S.StatusButton>{statusLabel}</S.StatusButton>
      {cancelReturnComment ? (
        <Typography color='secondaryGrey' scale='p3'>
          {formatMessage(PM.paymentMessages.cancelReturnComment)}:{' '}
          {cancelReturnComment}
        </Typography>
      ) : null}
      {showReturnDetailsLink ? (
        <S.Link onClick={handleViewReturnDetailsClick}>
          <Typography className='text'>
            {formatMessage(PM.paymentMessages.viewReturnDetails)}
          </Typography>
        </S.Link>
      ) : null}
    </S.OrderLineReturnInfoWrap>
  );
};

export default OrderLineReturnInfo;
